import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { getCensorRatingById } from '@vista-digital/occ-domain';
import { observer } from 'mobx-react';
import { useFilmContext } from '../../../context/film/hooks/use-film-context';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { FilmTitle as FilmTitleUI, FilmTitleSkeleton } from '../../../subcomponents/film-title/film-title';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { defaultFilmTitleProps, filmTitlePropsValidator } from './types/props';
export const FilmTitle = observer(props => {
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { film } = useFilmContext();
    if (!film)
        return enableSkeletonLoadingIndicators ? _jsx(FilmTitleSkeleton, {}) : null;
    const censorRating = film.censorRatingId ? getCensorRatingById(film.censorRatingId) : undefined;
    const { cdnOptions } = props, others = __rest(props, ["cdnOptions"]);
    return (_jsx(FilmTitleUI, Object.assign({ film: film, censorRating: censorRating, censorRatingIconCdnOptions: cdnOptions.censorRatingIcon }, others)));
});
FilmTitle.displayName = 'FilmTitle';
/**
 * The **Film Title** component renders a film's title.
 */
export const FilmTitleComponent = withComponentWrapper(FilmTitle, defaultFilmTitleProps, filmTitlePropsValidator);
//# sourceMappingURL=film-title.js.map